export default "/Frontend/dist/pdf-required.e7f820353166f443cbe814e63e58d5a2.svg";